/**
 * Boot loader snail: the merge-tier snail drawn in code into the loader's canvas.
 *
 * index.html runs this from a small inline script next to #gameLoader, so the snail is drawn
 * without waiting for the game bundle. In dev that is a module script; a build bundles this
 * file and its imports into a classic inline IIFE (vite.config.js inlineLoaderSnailPlugin),
 * which runs while the HTML is parsed, before the entry chunk has downloaded. It imports only
 * the creature drawers (not the art catalog or the registry) to keep that inlined code small,
 * and touches no shared state: the game's own copy of these modules is separate.
 */
import { LINE_BODY } from "../palette.js";
import { drawCreature } from "../creatures/index.js";

/**
 * @param {HTMLCanvasElement | null | undefined} cv `.game-loader__snail`
 * @returns {boolean} whether it drew
 */
export function paintLoaderSnail(cv) {
  if (!cv || typeof cv.getContext !== "function") return false;
  var c = null;
  try {
    c = cv.getContext("2d");
  } catch (_e) {
    c = null;
  }
  if (!c) return false;
  var w = cv.width, h = cv.height;
  // Same inscribed disc as the tier art (art-catalog creatureDiscRadius), so the ink rim fits.
  var r = (Math.min(w, h) / 2) / (1 + LINE_BODY * 0.5 + 0.004);
  c.clearRect(0, 0, w, h);
  c.save();
  c.translate(w / 2, h / 2);
  try {
    drawCreature(c, "snail", r, { t: 0 });
  } catch (err) {
    if (typeof console !== "undefined") console.warn("[loader] snail art failed", err);
  }
  c.restore();
  // The stage shows a plain disc until now; the class pops the drawn snail in.
  if (cv.classList) cv.classList.add("is-drawn");
  return true;
}
